module.exports = __webpack_public_path__ + "img/login.d9472dd5.png";